import { CON_ADJUSTMENTS } from "../constants/abilityAdjustments";

export function calculateConBonus(character) {

  let LookupKey = character.stats['myCon'].toString().replace(/[^0-9]/g, ''); // strip out non-numerical

  let CON_bonus_string ="";

  console.log('New class: ', character.chars.myClass)
  console.log('New con: ', character.stats.myCon)
  console.log('Lookup key: ', LookupKey )
  try {
    let CON_adj = JSON.parse(JSON.stringify(CON_ADJUSTMENTS[parseInt(LookupKey)])); // Deep copy

      if (!["Fighter", "Paladin", "Ranger"].includes(character.chars.myClass)) 
          { CON_adj.hitPointAdj = Math.min(2, CON_adj.hitPointAdj ); }

      let adjuster = CON_adj['hitPointAdj'];

      const bonus = adjuster === 0 ? "" :
        (adjuster < 0 ? `-${Math.abs(adjuster)}` : `+${adjuster}`);
      
      console.log('Con Saving Throw: ', bonus);

      CON_bonus_string = bonus
      
      return { str: CON_bonus_string, dict: CON_adj }
    
  } catch(error) {
    console.log('fail gracefully')
    console.log(error)
  }

}